import { render, staticRenderFns } from "./trainingsplanSlider.vue?vue&type=template&id=372f7d64&scoped=true"
import script from "./trainingsplanSlider.vue?vue&type=script&lang=js"
export * from "./trainingsplanSlider.vue?vue&type=script&lang=js"
import style0 from "./trainingsplanSlider.vue?vue&type=style&index=0&id=372f7d64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372f7d64",
  null
  
)

export default component.exports